import styled from 'styled-components';

const Separator = styled.div`
  height: ${({ height }) => `${height || 1}px`};
  background-color: ${({ transparent, theme: { COLORS } }) =>
    transparent ? 'transparent' : COLORS.BORDER};
`;

Separator.displayName = 'Separator';

export default Separator;
